import { LinkCard } from "./types";

export const linksData: LinkCard[] = [
  {
    title: "Business Meta Data Form",
    description: "Maintain business metadata directly in the data catalog",
    buttonText: "Business Meta Data Form",
    url: "#",
    linkFor: "business_metadata",
    disable: false,
  },
  {
    title: "Sagemaker Unified Studio Project",
    description: "Acquire your data, create data products via AI",
    buttonText: "Sagemaker Unified \n Studio Project",
    url: "#",
    linkFor: "sagemaker_studio",
    disable: false,
  },
  {
    title: "Github project",
    description: "Version control your projects files",
    buttonText: "Github project",
    url: "#",
    linkFor: "github_project",
    disable: false,
  },
  {
    title: "Posit Workbench",
    description: "Willing to analyze your data in Posit Workbench ?",
    buttonText: "Click here",
    url: "#",
    linkFor: "post_workbench",
    disable: false,
  },
  {
    title: "Application Logs",
    description: "View application logs and monitor your space in Grafana",
    buttonText: "View Logs",
    url: "#",
    linkFor: "grafana_logs",
    disable: false,
  },
];